var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-statements */
import React, { Fragment } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { translationsAtom, inlineEditAtom, localeAtom } from "../V2/atoms";

const parseMarkdownMarker = (
line,
regexp,
wrapper) =>
{var _matches$input;
  const matches = line.match(regexp);
  if (matches == null) {
    return matches;
  }
  const parts = (_matches$input = matches.input) === null || _matches$input === void 0 ? void 0 : _matches$input.split(matches[0]);
  return (/*#__PURE__*/
    React.createElement(React.Fragment, null,
    (parts === null || parts === void 0 ? void 0 : parts.length) && parts[0],
    wrapper(matches[1]),
    (parts === null || parts === void 0 ? void 0 : parts.length) && parts[1]
    ));

};

const parseMarkdownBoldMarker = (line) =>
parseMarkdownMarker(line, /\*{2}(.*)\*{2}/, (text) => /*#__PURE__*/_jsx("strong", {}, void 0, text));

const parseMarkdownItalicMarker = (line) =>
parseMarkdownMarker(line, /\*(.*)\*/, (text) => /*#__PURE__*/_jsx("i", {}, void 0, text));








const Translate = ({ className, children, context = 'System', translationKey }) => {
  const translations = useAtomValue(translationsAtom);
  const locale = useAtomValue(localeAtom);
  const [inlineEditState, setInlineEditState] = useAtom(inlineEditAtom);

  const language = translations.find((translation) => translation.locale === locale);
  const activeClassName = inlineEditState.inlineEdit ? 'translation active' : 'translation';

  const translationContext = (language === null || language === void 0 ? void 0 : language.contexts.find((ctx) => ctx.id === context)) || { values: {} };
  const text = translationContext.values[translationKey || children] || children;
  const lines = text ? text.split('\n') : [];

  return (/*#__PURE__*/
    _jsx("span", {
      onClick: (event) => {
        if (inlineEditState.inlineEdit) {
          event.stopPropagation();
          event.preventDefault();
          setInlineEditState({
            inlineEdit: inlineEditState.inlineEdit,
            context,
            translationKey: translationKey || children
          });
        }
      },
      className: `${activeClassName} ${className || ''}` }, void 0,

    lines.map((line, index) => {
      const boldMatches = parseMarkdownBoldMarker(line);
      const italicMatches = parseMarkdownItalicMarker(line);
      return (/*#__PURE__*/
        _jsx(Fragment, {}, `${line}-${index.toString()}`,
        boldMatches ||
        italicMatches || /*#__PURE__*/ // eslint-disable-next-line react/jsx-no-useless-fragment
        React.createElement(React.Fragment, null, line),

        index < lines.length - 1 && /*#__PURE__*/_jsx("br", {})
        ));

    })
    ));

};

export { Translate };